export default __webpack_public_path__ + "static/media/bg-hero.f5c91cdc.png";